import React, { useState } from 'react';
import useStyles from './styles';
import { Typography } from '@material-ui/core';
import JetFontIcon, {
  JET_FONTICON_ALIASES,
} from '@src/shared/components/JetFontIcon';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import FAQList from './FAQList/FAQList';
import FAQListPaginated from './FAQListPaginated/FAQListPaginated';
import { useTranslation } from 'react-i18next';
const FAQContent = (props: any) => {
  const classes = useStyles();
  const { isResolutionMobile, isTablet, isMobileDevice } = useDeviceDetect();
  const { t } = useTranslation()
  return (
    <div className={classes.faqContent}>
      <Typography
        variant={isResolutionMobile ? 'h3' : 'h1'}
        className={`${
          isResolutionMobile ? 'heading_l' : 'heading_xxl'
        } faqcontent-title`}
        align="center"
      >
        <JetFontIcon
          className="title-icon"
          iconname={JET_FONTICON_ALIASES.CHAT_HELP}
          size={isResolutionMobile ? 20 : 33}
        />{' '}
        {t('new_productoverview_common.section8_title')}
      </Typography>
      <div className={'faqcontent-questions-container'}>
          {!isMobileDevice && !isTablet ? <FAQList pageType={props.pageType} /> : <FAQListPaginated pageType={props.pageType} />}
      </div>
    </div>
  );
};

export default FAQContent;
